<template>
  <div class="collection-mobile-menu" :class="{'menu-active': menuActive}">
    <div class="collection-mobile-menu__header">
      <div class="collection-mobile-menu__header-title">
        <h5 class="h5">{{menuTitle}}</h5>
      </div>
      <icon class="collection-mobile-menu__header-close" @click="closeBinding" name="close" size="14px"></icon>
    </div>
    <div class="collection-mobile-menu__contents">
      <slot></slot>
      <div class="collection-mobile-menu__apply-button">
        <v-button v-if="enableApplyButton" :disabled="!currentFilterCount" :primary="true" :full="true" @click="closeBinding" :label="`APPLY${currentFilterCount}`"></v-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Icon from '@/scripts/components/basic/Icon.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'

export default {
  name: 'CollectionMobileMenuB',
  components: { Icon, VButton, VLink },
  props: {
    menuActive: {
      type: Boolean,
      default: false
    },
    menuTitle: {
      type: String,
      required: true
    },
    enableApplyButton: {
      type: Boolean,
      default: false
    },
    closeBinding: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentFilters: state => state.collections.currentFilters
    }),
    currentFilterCount() {
      return this.currentFilters && this.currentFilters.length ? ` (${this.currentFilters.length})` : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .collection-mobile-menu {
    background-color: $color-white;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    opacity: 0;
    transform: translate3d(-100%,0,0);
    transition: transform 250ms ease-in-out, opacity 200ms ease;
    display: flex;
    flex-direction: column;
    padding: 0 8px;
    &.menu-active {
      opacity: 1;
      transform: translate3d(0,0,0);
    }
    &__header {
      position: relative;
      align-items: center;
      background-color: $color-white;
      padding: 32px;
      &-title {
        width: 100%;
        text-align: center;
        /deep/ .link {
          margin-left: 16px;
        }
      }
      &-close {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &__contents {
      position: relative;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      padding-bottom: 120px;
    }
    &__apply-button {
      background-color: #fff;
      width: 100%;
      padding: $grid-gutter;
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: 100px;
      z-index: 1;
    }
    &__filters-clear {
      cursor: pointer;
    }
  }
</style>
